import { User, TokenPayload, LoginFormData, ApiResponse } from '../types';
import mockApi from './mockApi';

class AuthService {
  // Token'ı localStorage'dan al
  getToken(): string | null {
    return localStorage.getItem('token');
  }

  // Token'ı localStorage'a kaydet
  setToken(token: string): void {
    localStorage.setItem('token', token);
  }

  // Token'ı localStorage'dan sil
  removeToken(): void {
    localStorage.removeItem('token');
  }

  // Token'ı decode et
  decodeToken(token: string): TokenPayload | null {
    try {
      return JSON.parse(atob(token)) as TokenPayload;
    } catch (error) {
      console.error('Token decode hatası:', error);
      return null;
    }
  }

  // Token'ın geçerli olup olmadığını kontrol et
  isTokenValid(token: string): boolean {
    try {
      const decoded = this.decodeToken(token);
      if (!decoded) return false;
      
      const currentTime = Date.now() / 1000;
      return decoded.exp > currentTime;
    } catch (error) {
      return false;
    }
  }

  // Kullanıcı girişi
  async login(credentials: LoginFormData): Promise<ApiResponse<{ user: User; token: string }>> {
    try {
      const response = await mockApi.login(credentials);

      if (response.success && response.data?.token) {
        this.setToken(response.data.token);
      }

      return response;
    } catch (error) {
      console.error('Login hatası:', error);
      return {
        success: false,
        error: 'Sunucuya bağlanırken hata oluştu'
      };
    }
  }

  // Kullanıcı çıkışı
  logout(): void {
    this.removeToken();
  }

  // Mevcut kullanıcı bilgilerini al
  async getCurrentUser(): Promise<User | null> {
    const token = this.getToken();
    if (!token || !this.isTokenValid(token)) {
      return null;
    }

    try {
      const response = await mockApi.getCurrentUser(token);
      return response.success ? response.data || null : null;
    } catch (error) {
      console.error('Kullanıcı bilgileri alınırken hata:', error);
      return null;
    }
  }

  // Kullanıcının belirli bir role sahip olup olmadığını kontrol et
  async hasRole(requiredRoles: string[]): Promise<boolean> {
    const user = await this.getCurrentUser();
    if (!user) return false;
    
    return requiredRoles.includes(user.role);
  }

  // Kullanıcının admin olup olmadığını kontrol et
  async isAdmin(): Promise<boolean> {
    return this.hasRole(['admin']);
  }

  // Kullanıcının developer olup olmadığını kontrol et
  async isDeveloper(): Promise<boolean> {
    return this.hasRole(['admin', 'developer']);
  }

  // Kullanıcının mod olup olmadığını kontrol et
  async isMod(): Promise<boolean> {
    return this.hasRole(['admin', 'developer', 'mod']);
  }
}

const authService = new AuthService();
export default authService;
